export enum CommentViewModes {
    all,
    questions,
    polls,
    adminPanel
}